import { useState } from 'react'
import { useToast } from '@winnin/winnin_ui.components.toast'

import { useDashboardModals } from 'contexts/DashboardModalsContext'
import { useDashboardMutations } from 'hooks-queries/dashboards'
import { useTranslate } from 'lib/tolgee'
import { analyticsTracker, TOLGEE_GLOBALS } from 'utils'

import { EDIT_DASHBOARD_FOLDER_LOG } from './edit-dashboard-folder-modal.consts'
import { translations } from './edit-dashboard-folder-modal.i18n'
import type { IEditDashboardFolderModal } from './edit-dashboard-folder-modal.types'

export const useEditDashboardFolderModalModel = (): IEditDashboardFolderModal => {
  const { folder, setIsEditDashboardFolderOpen } = useDashboardModals()
  const [folderName, setFolderName] = useState(folder?.name || '')
  const { createToast } = useToast()
  const t = useTranslate()

  const [editJobExternalFolder, { loading }] = useDashboardMutations({
    errorLog: EDIT_DASHBOARD_FOLDER_LOG,
    mutationName: 'editJobExternalFolder',
    options: {
      refetchQueries: ['getListWorkspaceJobPaginated', 'GET_JOB_EXTERNAL_FOLDERS'],
    },
  })

  const handleEditFolder = () => {
    const { DASHBOARD_FOLDERS } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(DASHBOARD_FOLDERS.EDIT_FOLDER, {
      oldName: folder.name,
      folderName,
      folderId: folder.id,
    })

    editJobExternalFolder({
      variables: {
        input: {
          folderId: folder.id,
          name: folderName,
        },
      },
    })
      .then(({ data }) => {
        if (data.editWorkspaceJobExternalFolder?.name) {
          createToast({
            content: t(translations.editedMessage),
          })
        }
      })
      .catch(() => {
        createToast({
          content: t(TOLGEE_GLOBALS.somethingWentWrong),
        })
      })
      .finally(() => {
        handleClose()
      })
  }

  const handleInputChange: React.ChangeEventHandler<HTMLInputElement> &
    React.ChangeEventHandler<HTMLTextAreaElement> = event => {
    const value = event.target.value
    setFolderName(value)
  }

  const handleClose = () => {
    setIsEditDashboardFolderOpen(false)
  }

  const isSubmitDisabled = !folderName || loading

  return { handleEditFolder, handleInputChange, folderName, handleClose, isSubmitDisabled }
}
